// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__NQiZ1","purpleBorder":"styles_purpleBorder__Fl8RH","tealBorder":"styles_tealBorder__IjJYj"};